import { render, staticRenderFns } from "./FuncionarioManter.vue?vue&type=template&id=656135ee&"
import script from "./FuncionarioManter.vue?vue&type=script&lang=js&"
export * from "./FuncionarioManter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports